import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "user_active",
  "use": "user_active-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"user_active\"><g fill-rule=\"evenodd\"><path d=\"M10 1a9 9 0 0 1 7.927 13.265A14.924 14.924 0 0 0 10 12c-2.846 0-5.574.796-7.927 2.265A9 9 0 0 1 10 1Zm0 2.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Zm0 1a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Z\" /><path d=\"M10 13c2.719 0 5.256.775 7.404 2.116A8.986 8.986 0 0 1 10 19a8.99 8.99 0 0 1-7.404-3.882A13.916 13.916 0 0 1 10 13Z\" opacity=\".5\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol